import React from "react";

function Leaderboard() {
  const scores = JSON.parse(localStorage.getItem("scores")) || [];

  return (
    <div>
      <h3>Leaderboard</h3>
      <ul>
        {scores.map((s, i) => (
          <li key={i}>
            {s.user} | Moves: {s.moves} | Time: {s.time}s
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Leaderboard;
